import * as yup from 'yup';
import { ERegExpTypes } from 'constants/RegExpTypes';
import { useTranslations } from 'hooks/useTranslations';

export const useSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    newPassword: yup
      .string()
      .required(t('general.field.validation.required'))
      .min(8, t('resetPassword.passwordsCharacterValid.text'))
      .max(64, t('resetPassword.passwordsCharacterValid.text'))
      .test(
        'password-validation',
        t('resetPassword.passwordsCharacterValid.text'),
        (value) => {
          if (value) {
            const regex = new RegExp(ERegExpTypes.password);
            return regex.test(value);
          }
          return true;
        },
      ),

    newPasswordRepeat: yup
      .string()
      .required(t('general.field.validation.required'))
      .oneOf([yup.ref('newPassword')], t('resetPassword.passwordsMatch.text')),
  });
  return { schema };
};
